import { createStore } from "vuex";
import axios from "axios";
import { jwtDecode as jwtDecode } from 'jwt-decode';

// http://130.89.253.67:70
export default createStore({
  state: {
    user: null,
    api: "http://130.89.253.67:70",
  },

  getters: {
    loggedIn(state) {
      return !!state.user;
    },
  },
  mutations: {
    SET_USER_DATA(state, userData) {
      localStorage.setItem("user", JSON.stringify(userData));
      axios.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${userData.token}`;
      state.user = userData;
    },
    CLEAR_USER_DATA(state) {
      state.user = null;
      localStorage.removeItem("user");
      axios.defaults.headers.common["Authorization"] = null;
    },
  },
  actions: {
    updateToken({ commit, state }, refreshToken) {
      console.log("update token", refreshToken);
      console.log("Old token", state.user.token);
      commit("CLEAR_USER_DATA");
      return axios
        .post(state.api + "/api/v1/auth/refresh", refreshToken)
        .then(({ data }) => {
          commit("SET_USER_DATA", data);
          console.log("New token", state.user.token);
        });
    },
    checkTokenExpired({ state, dispatch }) {
      if (state.user && state.user.token) {
        const token = state.user.token;
        const decodedToken = jwtDecode(token);
        if (decodedToken && decodedToken.exp) {
          const currentTimestamp = Math.floor(Date.now() / 1000); // Convert to seconds
          const threshold = 300;
          if (decodedToken.exp - currentTimestamp < threshold) {
            return dispatch("updateToken", {
              token: state.user.refreshToken,
            });
          }
          // return decodedToken.exp - currentTimestamp < threshold;
        }
      }
      return false;
    },

    login({ commit, state }, credentials) {
      console.log(this.api, "api");
      return axios
        .post(state.api + "/api/v1/auth/signin", credentials)
        .then(({ data }) => {
          commit("SET_USER_DATA", data);
        });
    },

    // async getParagraphs(state) {
    //   return axios
    //     .get(state.api + "/api/v1/calculator/paragraphs")
    //     .then(({ data }) => {
    //       console.log("Response data:", data);
    //     })
    //     .catch((error) => {
    //       console.error("Error:", error);
    //     });
    // },


    logout({ commit }) {
      commit("CLEAR_USER_DATA");
    },

    async getTracersAdmin({ state, dispatch }) {
      await dispatch("checkTokenExpired");
      const response = await axios.get(state.api + "/api/v1/admin/getTracers");
      console.log("Response data:", response.data);
      return response.data;
    },

    async getTracers({ state, dispatch }) {
      await dispatch("checkTokenExpired");
      const response = await axios.get(state.api + "/api/v1/calculator/tracer");
      return response.data;
    },

    async getParagraphs({ state, dispatch }) {
      await dispatch("checkTokenExpired");
      const response = await axios.get(state.api + "/api/v1/calculator/paragraphs");
      return response.data;
    },

    async addTracer({ state, dispatch }, tracerData) {
      await dispatch("checkTokenExpired");

      return axios
        .post(state.api + "/api/v1/admin/uploadTracer", tracerData)
        .then(({ data }) => {
          console.log("Response data:", data);
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    },

    async calculate({ state, dispatch }, calculatorInput) {
      await dispatch("checkTokenExpired");
      const response = await axios.post(
        state.api + "/api/v1/calculator",
        calculatorInput
      );
      return response.data;
    },

    async deleteTracer({ state, dispatch }, deleteData) {
      await dispatch("checkTokenExpired");
      console.log("data", deleteData);
      return axios.delete(state.api + "/api/v1/admin/deleteTracer", { data: deleteData })
        .then(response => {
          // Handle the response
        })
        .catch(error => {
          console.error("Error deleting tracer:", error);
        });
    },

    async deleteParagraph({ state, dispatch }, deleteData) {
      await dispatch("checkTokenExpired");
      console.log("data", deleteData);
      return axios.delete(state.api + "/api/v1/admin/deleteParagraph", { data: deleteData })
        .then(response => {
          // Handle the response
        })
        .catch(error => {
          console.error("Error deleting tracer:", error);
        });

    },


    async addParagraph({ state, dispatch }, paragraphData) {
      await dispatch("checkTokenExpired");
      return axios
        .post(state.api + "/api/v1/admin/uploadParagraph", paragraphData)
        .then(({ data }) => {
          console.log("Response data:", data);
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    },

    async updateParagraph({ state, dispatch }, paragraphData) {

      console.log("paragraphData", paragraphData);
      await dispatch("checkTokenExpired");
      return axios
        .put(state.api + "/api/v1/admin/updateParagraph", paragraphData)
        .then(({ data }) => {
          console.log("Response data:", data);
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    },

    // addParagraph({ state }, { paragraphData }) {
    //   const config = {
    //     headers: {
    //       Authorization: `Bearer ${state.user.token}`,
    //       "Content-Type": "application/json", // Added Content-Type header
    //     },
    //   };

    //   return axios
    //     .post(
    //       state.api + "/api/v1/admin/uploadParagraph",
    //       paragraphData,
    //       config
    //     )
    //     .then(({ data }) => {
    //       console.log("Response data:", data);
    //     })
    //     .catch((error) => {
    //       console.error("Error:", error);
    //     });
    // },
  },
  modules: {},
});
